import { MARQUEE_ITEMS } from "../data/tour";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-vine bg-moss py-5">
      <div className="marquee-track flex w-max items-center gap-10">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap text-xs uppercase tracking-[0.3em] text-sage/70">
            {item}
            <span className="text-marigold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
